<template>
  <v-container class="pa-6">
    <v-row align="center">
      <v-col cols="auto" class="pr-0">
        <div class="text-h5">
          <span
            style="
              font-family: Inter;
              text-transform: uppercase;
              font-weight: 600;
            "
          >
            Setup
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <IngestorsTable
          @addNewIngestor="$emit('addNewIngestor')"
          @editIngestor="callEditIngestor"
          @setIngestorAccessKey="callSetIngestorAccessKey"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <SettingsGroupManager />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IngestorsTable from '../components/Setup/IngestorsTable.vue';
import SettingsGroupManager from '../components/Setup/SettingsGroupManager';

export default {
  components: {
    IngestorsTable,
    SettingsGroupManager,
  },
  data: () => ({
    overlayMode: null,
    overlay: false,
    overlayMetricsAndAlerts: false,
  }),
  computed: {
    authStatus() {
      return this.$store.state.auth.status;
    },
  },
  methods: {
    callEditIngestor(id) {
      this.$emit('editIngestor', id);
    },
    callSetIngestorAccessKey(id) {
      this.$emit('setIngestorAccessKey', id);
    },
  },
};
</script>

<style></style>
